import { useEffect, useState } from "react";
import { updateMaterial } from "@/lib/manufacturingClient";
import {
  mergeReorderThresholdMetadata,
  parseReorderThresholdInput,
  reorderThresholdFromMetadata,
} from "@/lib/manufacturing/reorderThreshold";
import type { MfgMaterial } from "@/lib/manufacturing/types";
import { MaterialReorderThresholdField } from "./MaterialReorderThresholdField";
import { mfgSecondaryBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

export function ManufacturingInventoryMaterialReorderField(props: {
  material: MfgMaterial;
  onMaterial: (m: MfgMaterial) => void;
  onChanged: () => void;
}) {
  const current = reorderThresholdFromMetadata(props.material.metadata);
  const [draft, setDraft] = useState(current == null ? "" : String(current));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const next = reorderThresholdFromMetadata(props.material.metadata);
    setDraft(next == null ? "" : String(next));
    setError(null);
  }, [props.material.id]);

  async function save() {
    const parsed = parseReorderThresholdInput(draft);
    if (!parsed.ok) {
      setError(parsed.error);
      return;
    }
    setError(null);
    setBusy(true);
    const r = await updateMaterial({
      material_id: props.material.id,
      reorder_threshold: parsed.value,
    });
    setBusy(false);
    if (!r.ok) {
      setError(r.error);
      return;
    }
    props.onMaterial({
      ...props.material,
      metadata: mergeReorderThresholdMetadata(props.material.metadata ?? {}, parsed.value),
    });
    props.onChanged();
  }

  return (
    <div className="space-y-2 rounded-lg border border-gray-200 px-3 py-2 dark:border-zinc-700">
      <MaterialReorderThresholdField value={draft} onChange={setDraft} disabled={busy} />
      {error ? <p className="text-xs text-red-700">{error}</p> : null}
      <button type="button" className={mfgSecondaryBtnClass} disabled={busy} onClick={() => void save()}>
        {busy ? "Saving…" : "Save reorder"}
      </button>
    </div>
  );
}
